export default __webpack_public_path__ + "static/banner-the-ultimate-guide-to-budget-or-spending-09eb8f34199650cb2ab93c8fcd2b9cb5.jpg";